"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _padStart = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/pad-start"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var EmojiProvider = _interopRequireWildcard(require("@/libs/EmojiProvider"));
var settingTools = _interopRequireWildcard(require("@/libs/settingTools"));
var _autocompleteCommands = _interopRequireDefault(require("@/res/autocompleteCommands"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _AutoComplete = _interopRequireDefault(require("./AutoComplete"));
var _TextStyle = _interopRequireDefault(require("./inputtools/TextStyle"));
var _Emoji = _interopRequireDefault(require("./inputtools/Emoji"));
var _SelfUser = _interopRequireDefault(require("./SelfUser"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _TypingUsersList = _interopRequireDefault(require("./TypingUsersList"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// IRC formatting control characters
var IRC_BOLD = '\x02'; // ^B
var IRC_ITALIC = '\x1D'; // ^]
var IRC_UNDERLINE = '\x1F'; // ^_
var IRC_COLOUR = '\x03'; // ^C
var IRC_RESET = '\x0F'; // ^O
var _default = exports.default = {
  components: {
    AutoComplete: _AutoComplete.default,
    AwayStatusIndicator: _AwayStatusIndicator.default,
    SelfUser: _SelfUser.default,
    TypingUsersList: _TypingUsersList.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      selfuser_open: false,
      autocomplete_open: false,
      autocomplete_items: [],
      autocomplete_filter: '',
      autocomplete_filtering: true,
      active_tool: null,
      active_tool_props: {},
      pluginUiElements: _GlobalApi.default.singleton().controlInputPlugins,
      showPlugins: false,
      showCommandWarning: false,
      current_input_value: '',
      has_focus: false,
      keep_focus: false,
      activeFormats: {
        bold: false,
        italic: false,
        underline: false,
        fgColour: -1,
        bgColour: -1
      }
    };
  },
  computed: {
    currentNick: function currentNick() {
      var activeNetwork = this.$state.getActiveNetwork();
      return activeNetwork ? activeNetwork.nick : '';
    },
    networkState: function networkState() {
      var activeNetwork = this.$state.getActiveNetwork();
      return activeNetwork ? activeNetwork.state : '';
    },
    shouldShowSendButton: function shouldShowSendButton() {
      return this.$state.ui.is_touch || this.$state.setting('showSendButton');
    },
    shouldShowEmojiPicker: function shouldShowEmojiPicker() {
      return this.$state.setting('forceShowEmojiPicker') || this.$state.setting('showEmojiPicker') && !this.$state.ui.is_touch;
    },
    shouldShowColorPicker: function shouldShowColorPicker() {
      return this.$state.setting('showColorPicker');
    },
    shouldShowTools: function shouldShowTools() {
      if (this.pluginUiElements.length || this.shouldShowEmojiPicker || this.shouldShowColorPicker) {
        return true;
      }
      return false;
    },
    shouldShowToolsInline: function shouldShowToolsInline() {
      var toolCount = this.pluginUiElements.length;
      if (this.shouldShowEmojiPicker) {
        toolCount++;
      }
      if (this.shouldShowColorPicker) {
        toolCount++;
      }
      if (toolCount === 1) {
        return true;
      }
      return 36 * toolCount < this.$state.ui.app_width / 5;
    },
    history: function history() {
      if (this.$state.setting('buffers.shared_input')) {
        return this.$state.ui.input_history;
      }
      return this.buffer.input_history;
    },
    history_pos: {
      get: function get() {
        if (this.$state.setting('buffers.shared_input')) {
          return this.$state.ui.input_history_pos;
        }
        return this.buffer.input_history_pos;
      },
      set: function set(newVal) {
        if (this.$state.setting('buffers.shared_input')) {
          this.$state.ui.input_history_pos = newVal;
        } else {
          this.buffer.input_history_pos = newVal;
        }
      }
    }
  },
  watch: {
    history_pos: function history_pos(newVal) {
      var val = this.history[this.history_pos];
      this.$refs.input.setValue(val || '');
    },
    buffer: function buffer() {
      if (!this.$state.setting('buffers.shared_input')) {
        this.inputRestore();
      }
      this.autocomplete_open = false;
    }
  },
  created: function created() {
    var _this = this;
    this.typingTimer = null;
    this.lastTypingTime = 0;
    this.listen(this.$state, 'document.keydown', function (ev) {
      if (!_this.$refs.input) {
        return;
      }
      if (ev.ctrlKey || ev.altKey || ev.metaKey) {
        return;
      }
      if (ev.key === 'Shift') {
        return;
      }
      var arrowKeyCodes = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'];
      if (ev.shiftKey && arrowKeyCodes.indexOf(ev.key) !== -1) {
        return;
      }
      var elements = ['input', 'select', 'textarea', 'button', 'datalist', 'keygen'];
      var doNotRefocus = elements.indexOf(ev.target.tagName.toLowerCase()) > -1 || ev.target.getAttribute('contenteditable');
      if (doNotRefocus) {
        return;
      }
      _this.$refs.input.focus();
    });
    this.listen(this.$state, 'input.insertnick', function (nick) {
      if (!_this.$refs.input) {
        return;
      }
      var val = nick;
      if (_this.current_input_value === '') {
        val += ': ';
      } else {
        val += ' ';
      }
      _this.$refs.input.insertText(val);
    });
    this.listen(this.$state, 'input.tool', function (toolComponent) {
      _this.toggleInputTool(toolComponent);
    });
  },
  mounted: function mounted() {
    this.inputRestore();
  },
  methods: {
    inputUpdate: function inputUpdate(val) {
      this.current_input_value = val;
      if (this.$state.setting('buffers.shared_input')) {
        this.$state.ui.current_input = val;
      } else {
        this.buffer.current_input = val;
      }
      this.showCommandWarning = false;
      this.maybeHidePlugins();
    },
    inputRestore: function inputRestore() {
      var currentInput = this.$state.setting('buffers.shared_input') ? this.$state.ui.current_input : this.buffer.current_input;
      this.$refs.input.reset(currentInput, this.keep_focus);
      this.$refs.input.selectionToEnd();
    },
    toggleSelfUser: function toggleSelfUser() {
      if (this.networkState === 'connected') {
        this.selfuser_open = !this.selfuser_open;
      }
    },
    maybeHidePlugins: function maybeHidePlugins() {
      if (this.$state.ui.app_width < 500) {
        this.showPlugins = false;
      }
    },
    onToolClickTextStyle: function onToolClickTextStyle() {
      this.toggleInputTool(_TextStyle.default);
    },
    onToolClickEmoji: function onToolClickEmoji() {
      this.toggleInputTool(_Emoji.default);
    },
    closeToolsPlugins: function closeToolsPlugins() {
      this.showPlugins = false;
      this.closeInputTool();
    },
    closeInputTool: function closeInputTool() {
      this.active_tool = null;
    },
    toggleInputTool: function toggleInputTool(tool) {
      if (!tool || this.active_tool === tool) {
        this.active_tool = null;
      } else {
        this.active_tool_props = {
          buffer: this.buffer,
          ircinput: this.$refs.input,
          activeFormats: this.activeFormats
        };
        this.active_tool = tool;
      }
    },
    // ─── IRC formatting ───────────────────────────────────────────────
    /**
     * Build the IRC format prefix string from activeFormats state.
     * This is prepended to the message text on submit so no control
     * characters are ever inserted into the visible input box.
     */
    buildFormatPrefix: function buildFormatPrefix() {
      var prefix = '';
      if (this.activeFormats.bold) prefix += IRC_BOLD;
      if (this.activeFormats.italic) prefix += IRC_ITALIC;
      if (this.activeFormats.underline) prefix += IRC_UNDERLINE;
      if (this.activeFormats.fgColour >= 0) {
        var _context;
        var fg = (0, _padStart.default)(_context = String(this.activeFormats.fgColour)).call(_context, 2, '0');
        if (this.activeFormats.bgColour >= 0) {
          var _context2;
          var bg = (0, _padStart.default)(_context2 = String(this.activeFormats.bgColour)).call(_context2, 2, '0');
          prefix += IRC_COLOUR + fg + ',' + bg;
        } else {
          prefix += IRC_COLOUR + fg;
        }
      }
      return prefix;
    },
    resetActiveFormats: function resetActiveFormats() {
      this.activeFormats.bold = false;
      this.activeFormats.italic = false;
      this.activeFormats.underline = false;
      this.activeFormats.fgColour = -1;
      this.activeFormats.bgColour = -1;
    },
    toggleBold: function toggleBold() {
      this.activeFormats.bold = !this.activeFormats.bold;
    },
    toggleItalic: function toggleItalic() {
      this.activeFormats.italic = !this.activeFormats.italic;
    },
    toggleUnderline: function toggleUnderline() {
      this.activeFormats.underline = !this.activeFormats.underline;
    },
    onTextStyleFormat: function onTextStyleFormat(type, value) {
      switch (type) {
        case 'bold':
          this.activeFormats.bold = !this.activeFormats.bold;
          break;
        case 'italic':
          this.activeFormats.italic = !this.activeFormats.italic;
          break;
        case 'underline':
          this.activeFormats.underline = !this.activeFormats.underline;
          break;
        case 'colour':
          // Toggle off if same colour clicked again
          this.activeFormats.fgColour = this.activeFormats.fgColour === value ? -1 : value;
          break;
        case 'bgcolour':
          this.activeFormats.bgColour = this.activeFormats.bgColour === value ? -1 : value;
          break;
        case 'reset':
          this.resetActiveFormats();
          break;
        default:
          break;
      }
    },
    // ─── Autocomplete ─────────────────────────────────────────────────
    onAutocompleteCancel: function onAutocompleteCancel() {
      this.autocomplete_open = false;
    },
    onAutocompleteTemp: function onAutocompleteTemp(selectedValue, selectedItem) {
      if (!this.autocomplete_filtering) {
        this.$refs.input.setCurrentWord(selectedValue);
      }
    },
    onAutocompleteSelected: function onAutocompleteSelected(selectedValue, selectedItem) {
      var word = selectedValue;
      if (word.length > 0) {
        this.$refs.input.setCurrentWord(word);
      }
      this.autocomplete_open = false;
    },
    // ─── Keyboard handling ────────────────────────────────────────────
    inputKeyDown: function inputKeyDown(event) {
      var _this2 = this;
      var meta = false;
      if (navigator.appVersion.indexOf('Mac') !== -1) {
        meta = event.metaKey;
      } else {
        meta = event.ctrlKey;
      }
      if (this.autocomplete_open && this.$refs.autocomplete.handleOnKeyDown(event)) {
        return;
      }
      if (this.autocomplete_open && !this.autocomplete_filtering) {
        this.$refs.autocomplete.selectCurrentItem();
      }
      if (event.key === 'Enter' && (event.altKey && !event.shiftKey && !event.metaKey && !event.ctrlKey || event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey)) {
        event.preventDefault();
        this.$refs.input.insertText('\n');
      } else if (event.key === 'Enter') {
        event.preventDefault();
        this.submitForm();
      } else if (event.key === 'Escape' && this.showCommandWarning) {
        this.showCommandWarning = false;
      } else if (event.key === ' ') {
        if (this.$state.setting('buffers.show_emoticons')) {
          var currentWord = this.$refs.input.getCurrentWord(true);
          var emojis = EmojiProvider.getEmojis(currentWord.word);
          if (emojis.length) {
            event.preventDefault();
            this.$refs.input.setCurrentWord('', false, true);
            this.$refs.input.addImg(emojis[0].ascii, emojis[0].url, emojis[0].imgProps);
          }
        }
      } else if (event.key === 'ArrowUp') {
        if (this.$refs.input.getCaretIdx() > 0) {
          return;
        }
        event.preventDefault();
        this.historyBack();
      } else if (event.key === 'ArrowDown') {
        var end = this.$refs.input.getRawText().replace(/\r?\n/g, '').length;
        if (this.$refs.input.getCaretIdx() < end) {
          return;
        }
        event.preventDefault();
        this.historyForward();
        this.$nextTick(function () {
          _this2.$refs.input.selectionToEnd();
        });
      } else if (event.key === 'Tab' && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
        var _currentWord = this.$refs.input.getCurrentWord();
        var currentToken = _currentWord.word.substr(0, _currentWord.position);
        var inputText = this.$refs.input.getRawText();
        var items = [];
        if (inputText.indexOf('/set') === 0) {
          items = this.buildAutoCompleteItems({
            settings: true
          });
        } else {
          items = this.buildAutoCompleteItems({
            users: true,
            buffers: true
          });
        }
        this.openAutoComplete(items);
        this.autocomplete_filter = currentToken;
        this.autocomplete_filtering = false;
        event.preventDefault();
      } else if (meta && event.key === 'k') {
        this.toggleInputTool(_TextStyle.default);
        event.preventDefault();
      } else if (meta && event.key === 'b') {
        this.toggleBold();
        event.preventDefault();
      } else if (meta && event.key === 'i') {
        this.toggleItalic();
        event.preventDefault();
      } else if (meta && event.key === 'u') {
        this.toggleUnderline();
        event.preventDefault();
      }
    },
    inputKeyUp: function inputKeyUp(event) {
      var inputVal = this.$refs.input.getRawText();
      var currentWord = this.$refs.input.getCurrentWord();
      var currentToken = currentWord.word.substr(0, currentWord.position);
      var autocompleteTokens = this.$state.setting('autocompleteTokens');
      if (event.key === 'Escape' && this.autocomplete_open) {
        this.autocomplete_open = false;
      } else if (this.autocomplete_open && currentToken === '') {
        this.autocomplete_open = false;
      } else if (this.autocomplete_open) {
        if (currentToken[0] === '@') {
          currentToken = currentToken.substr(1);
        }
      } else if (currentToken === '@' && (0, _includes.default)(autocompleteTokens).call(autocompleteTokens, '@')) {
        this.openAutoComplete(this.buildAutoCompleteItems({
          users: true
        }));
        this.autocomplete_filtering = true;
      } else if (inputVal === '/' && (0, _includes.default)(autocompleteTokens).call(autocompleteTokens, '/')) {
        this.openAutoComplete(this.buildAutoCompleteItems({
          commands: true
        }));
        this.autocomplete_filtering = true;
      } else if (currentToken === '#' && (0, _includes.default)(autocompleteTokens).call(autocompleteTokens, '#')) {
        this.openAutoComplete(this.buildAutoCompleteItems({
          buffers: true
        }));
        this.autocomplete_filtering = true;
      } else if (event.key === 'Tab' && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
        event.preventDefault();
      } else if (!event.key.match(/^(Shift|Control|Alt|Enter)/)) {
        if (inputVal[0] === '/') {
          return;
        }
        if ((0, _trim.default)(inputVal).call(inputVal)) {
          this.startTyping();
        } else {
          this.stopTyping(true);
        }
      }
      if (this.autocomplete_open && this.autocomplete_filtering) {
        this.autocomplete_filter = currentToken;
      }
    },
    // ─── Form submission ──────────────────────────────────────────────
    submitForm: function submitForm() {
      var rawInput = this.$refs.input.getValue();
      if (!rawInput) {
        if (!this.has_focus && this.keep_focus) {
          this.$refs.input.focus();
        }
        return;
      }
      var ircText = this.$refs.input.buildIrcText();

      // Prepend active IRC format codes so they apply to the whole message.
      // We do this here rather than inserting into the input, so the user
      // never sees raw control characters or colour numbers while typing.
      var formatPrefix = this.buildFormatPrefix();
      if (formatPrefix) {
        var _context3;
        ircText = (0, _map.default)(_context3 = ircText.split('\n')).call(_context3, function (line) {
          // Don't prepend to command lines
          if (line.indexOf('/') === 0) return line;
          return formatPrefix + line + IRC_RESET;
        }).join('\n');
      }
      var warnExpectedCommand = this.$state.setting('buffers.warn_expected_command');
      if (warnExpectedCommand && !this.showCommandWarning) {
        var spacePrecededCommand = /^\s+\//;
        var hasPrecedingSpace = ircText.split('\n').some(function (line) {
          return spacePrecededCommand.test(Misc.stripStyles(line));
        });
        if (hasPrecedingSpace) {
          this.showCommandWarning = true;
          return;
        }
      }
      this.$state.$emit('input.raw', ircText);
      this.historyAdd(rawInput);
      this.$refs.input.reset('', this.keep_focus);
      this.stopTyping(false);
    },
    // ─── History ──────────────────────────────────────────────────────
    historyAdd: function historyAdd(rawInput) {
      var _context4;
      this.history.push(rawInput);
      (0, _splice.default)(_context4 = this.history).call(_context4, 0, this.history.length - 50);
      this.history_pos = this.history.length;
    },
    historyBack: function historyBack() {
      var rawText = this.$refs.input.getRawText();
      var rawInput = this.$refs.input.getValue();
      if ((0, _trim.default)(rawText).call(rawText) && this.history_pos === this.history.length) {
        this.historyAdd(rawInput);
        this.history_pos--;
      }
      if (this.history_pos > 0) {
        this.history_pos--;
      }
    },
    historyForward: function historyForward() {
      if (this.history_pos < this.history.length) {
        this.history_pos++;
      }
    },
    // ─── Focus ────────────────────────────────────────────────────────
    focusChanged: function focusChanged(event) {
      this.has_focus = event.type === 'focus';
      if (event.type === 'blur' && event.relatedTarget && event.relatedTarget === this.$refs.sendButton) {
        return;
      }
      this.keep_focus = event.type === 'focus';
    },
    // ─── Autocomplete helpers ─────────────────────────────────────────
    openAutoComplete: function openAutoComplete(items) {
      if (this.$state.setting('showAutocomplete')) {
        this.autocomplete_items = items;
        this.autocomplete_open = true;
      }
    },
    buildAutoCompleteItems: function buildAutoCompleteItems(_opts) {
      var opts = _opts || {};
      var list = [];
      if (opts.users) {
        var _context5;
        var userList = (0, _map.default)(_context5 = (0, _values.default)(_lodash.default).call(_lodash.default, this.buffer.users)).call(_context5, function (user) {
          return {
            text: user.nick,
            type: 'user'
          };
        });
        if (this.buffer.isQuery()) {
          userList.push({
            text: this.buffer.name,
            type: 'user'
          });
        }
        list = (0, _concat.default)(list).call(list, userList);
      }
      if (opts.buffers) {
        var bufferList = [];
        this.network.buffers.forEach(function (buffer) {
          if (buffer.isChannel()) {
            bufferList.push({
              text: buffer.name,
              type: 'buffer'
            });
          }
        });
        list = (0, _concat.default)(list).call(list, bufferList);
      }
      if (opts.commands) {
        var commandList = [];
        _autocompleteCommands.default.forEach(function (command) {
          var _context6;
          var desc = command.description.indexOf('locale_id_') === 0 ? TextFormatting.t(command.description.substr(10)) : command.description;
          commandList.push({
            text: '/' + command.command,
            description: desc,
            type: 'command',
            alias: (0, _map.default)(_context6 = command.alias || []).call(_context6, function (c) {
              return '/' + c;
            })
          });
        });
        list = (0, _concat.default)(list).call(list, commandList);
      }
      if (opts.settings) {
        var _context7;
        var out = {};
        var base = [];
        settingTools.buildTree(out, base, this.$state.getSetting('settings'), false);
        settingTools.buildTree(out, base, this.$state.getSetting('user_settings'), true);
        var settingList = (0, _map.default)(_context7 = (0, _keys.default)(out)).call(_context7, function (setting) {
          return {
            text: setting,
            type: 'setting'
          };
        });
        list = (0, _concat.default)(list).call(list, settingList);
      }
      return list;
    },
    // ─── Typing indicators ────────────────────────────────────────────
    startTyping: function startTyping() {
      var _this3 = this;
      if (!this.network.ircClient.network.cap.isEnabled('message-tags')) return;
      if (!this.buffer || !this.buffer.shouldShareTyping()) return;
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.typingTimer = null;
      }
      this.typingTimer = setTimeout(function () {
        return _this3.stopTyping(true);
      }, 3000);
      if (Date.now() < this.lastTypingTime + 3000) return;
      this.network.ircClient.typing.start(this.buffer.name);
      this.lastTypingTime = Date.now();
    },
    stopTyping: function stopTyping(sendStop) {
      var _context8;
      if (!this.network.ircClient.network.cap.isEnabled('message-tags')) return;
      if (!this.buffer || !this.buffer.shouldShareTyping()) return;
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.typingTimer = null;
        this.lastTypingTime = 0;
      }
      (0, _trim.default)(_context8 = this.$refs.input.getRawText()).call(_context8) ? this.network.ircClient.typing.pause(this.buffer.name) : this.network.ircClient.typing.stop(this.buffer.name, sendStop);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ControlInput"]
window._kiwi_exports.components.ControlInput = exports.default ? exports.default : exports;
